export default {
    translation: {
        title: "Amérique",
        applications: "Applications",
        full_text: "Texte complet",
        vehicle: {
            status: "Conduite vers {{direction}} à {{speed}} mph."
        },
        talkie: {
            drivers_nearby_singular: "1 conducteur à proximité",
            drivers_nearby_plural: "{{count}} conducteurs à proximité"
        },
        settings: {
            save_progress_description:
                "Sauvegardez votre progression sur une disquette pour une sauvegarde ou un transfert entre ordinateurs.",
            save_progress_action: "Sauvegarder la progression",
            load_progress_action: "Charger la progression...",
            display_units: "Unités d'affichage",
            imperial: "Impériales",
            metric: "Métriques",
            start_over_description:
                "Terminez votre voyage prématurément. La progression actuelle sera effacée. Cette action est irréversible.",
            start_over_action: "Recommencer"
        },
        feedback: {
            message: "Message",
            contact_info: "Coordonnées (facultatif)",
            send: "Envoyer",
            sending: "Envoi en cours..."
        },
        radio: {
            no_reception: "aucune réception radio dans cette zone",
            low_signal: "signal faible",
            turn_off: "Éteindre",
            turn_on: "Allumer",
            next_station: "Station suivante",
            unmute: "Réactiver le son",
            mute: "Couper le son"
        },
        photos: {
            source: "Depuis Mapillary",
            empty: "Je regarde autour pour prendre une photo..."
        },
        news: {
            loading: "Je consulte les titres locaux...",
            nothing_found: "Rien trouvé."
        },
        metrics: {
            duration_title: "Temps de conduite",
            duration_value: "{{days}}j {{hours}}h {{minutes}}m",
            distance_title: "Distance parcourue",
            emissions_title: "CO2 d'échappement",
            emissions_value_g: "{{g}} g",
            emissions_value_kg: "{{kg}} kg",
            states_visited_title: "États visités",
            cairns_discovered_title: "Cairns découverts",
            exploration_title: "Exploration"
        },
        compass: {
            north_east: "Nord-Est",
            east: "Est",
            south_east: "Sud-Est",
            south: "Sud",
            south_west: "Sud-Ouest",
            west: "Ouest",
            north_west: "Nord-Ouest",
            north: "Nord"
        },
        landing: {
            about_title: "À propos",
            start_title: "Démarrer",
            features_title: "Fonctionnalités",
            about_headline: "America : simulateur de road trip dans votre navigateur",
            about_paragraph_1:
                "Safari, Chrome, Edge. Ce sont des portails vers les coins infinis du web.\n"
                + "America est votre portail vers un autre type de terrain vaste : les merveilles\n"
                + "naturelles des États-Unis, où il y a autant à apprendre, au rythme que vous\n"
                + "choisissez.",
            about_paragraph_2:
                "Des paysages monumentaux aux moments tranquilles au bord de la route, vous\n"
                + "dirigez le voyage à travers une interface fenêtrée style bureau : carte, radio\n"
                + "en direct, articles d'encyclopédie, galerie photo, métriques, journal et plus\n"
                + "encore. Pas de score, pas de précipitation : la sérendipité et l'atmosphère\n"
                + "d'abord. Ouvrez-le dans un navigateur moderne ; rien à installer.",
            about_paragraph_3:
            "Votre road trip peut longer la Pacific Coast Highway, tracer la Route 66 à"
                + "travers les plaines, serpenter dans les Rocheuses vers les parcs nationaux ou"
                + "errer sur les routes secondaires de Nouvelle-Angleterre. Chaque arrêt révèle"
                + "l'histoire locale : ce que cette ville, ce canyon ou ce belvédère a vu, ce que"
                + "passe la radio et le temps qu'il fait en ce moment. C'est un simulateur de"
                + "road trip pour explorer les États-Unis à votre rythme, depuis votre navigateur.",

            trips_title: "Explorer par voyage",
            trips_list: [
                { label: "Road trip virtuel", url: "/virtual-road-trip/" },
                { label: "Road trip aux États-Unis", url: "/us-road-trip/" },
                { label: "Road trip dans les parcs nationaux", url: "/national-parks-road-trip/" },
                { label: "Road trip sur la Route 66", url: "/route-66-road-trip/" },
                { label: "Explorer l'Amérique", url: "/explore-america/" },
                { label: "Road trip à travers l'Amérique", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "Voir la publicité",
            start_cta: "Commencer le voyage",
            start_cta_lead: "Pas d'installation. Fonctionne dans votre navigateur.",
            features_lede:
                "Une fois votre voyage commencé, vous configurez le tableau de bord à partir de\n"
                + "la suite de road trip d'America. Chaque fenêtre est une façon différente\n"
                + "d'expérimenter le pays. De la radio locale à un talkie-walkie avec d'autres\n"
                + "conducteurs, vous êtes sûr de découvrir quelque chose de nouveau à chaque\n"
                + "voyage.",
            features_list: [
                "Carte avec itinéraire et exploration à travers les États-Unis",
                "Radio en streaming et articles et photos liés aux lieux",
                "Journal, métriques, galerie photo et encyclopédie",
                "Amis, chat vocal et repères partagés sur la route (cairns)",
                "Fonctionne dans le navigateur sur téléphone ou ordinateur ; sans téléchargement",
            ],
            media_alt: "America Complete Edition : boîte logicielle et CD",
            slideshow_alt: "Photographie de paysages de road trip du simulateur America, image",
            og_title: "America : Simulateur de road trip",
            og_description:
                "Explorez les merveilles naturelles des États-Unis dans un simulateur de road trip ludique style bureau. Cartes, radio, journal et découvertes fortuites, directement dans votre navigateur.",
            twitter_description:
                "Explorez les merveilles naturelles des États-Unis dans un simulateur de road trip ludique style bureau. Pas d'installation.",
            meta_description:
                "Parcourez les routes des États-Unis et explorez ses merveilles naturelles dans un simulateur de road trip gratuit. Cartes, radio, photos. Sans téléchargement.",
            jsonld_description:
                "America est un simulateur de road trip dans votre navigateur : explorez les merveilles naturelles des États-Unis à votre rythme avec des cartes, de la radio, des photos et une interface style bureau. Sans téléchargement ; commencez votre voyage en ligne.",
            jsonld_genre: ["Simulateur de road trip", "Jeu d'exploration", "Jeu de navigateur"],
            page_title: "Simulateur de road trip aux États-Unis | America",
            html_lang: "fr",
            og_locale: "fr_FR",
            og_locale_alternate: ["en_US", "es_ES", "de_DE", "ru_RU", "ja_JP", "ko_KR", "zh_CN", "pt_BR"],
            og_image_alt: "Capture d'écran du simulateur de road trip America",
            twitter_image_alt: "Capture d'écran du simulateur de road trip America",
        },
    }
};
